module.exports = __webpack_public_path__ + "static/media/whatsappIcon.957c88a4.svg";